import { useEffect, useState } from 'react';

import AnimatedDots from '@webclient/components/pages/search/sections/results/real-time/components/animated-dots';
import StyledCenteredStack from '@webclient/components/pages/search/sections/results/real-time/components/voice-mode-chat/animated-avatar/loading-view/styles';
import {
  StyledBox,
  StyledImage,
} from '@webclient/components/pages/search/sections/results/real-time/components/voice-mode-chat/animated-avatar/styles';

import CONFIG from '@webclient/lib/const/bots';
import createPublicImageUrl, {
  retrieveImageWithFallback,
} from '@webclient/lib/createPublicImageUrl';
import getAvatar from '@webclient/lib/getAvatar';

import useAppSelector from '@webclient/hooks/useAppSelector';

import { selectBot } from '@webclient/state/slices/app-settings/userSettingSelector';

import { Text } from '@knowz/knowz-ui';

const BOTS_AVATAR_FALLBACK =
  'https://asset.knowz.com/assets/images/not-found-characters-avatar-%5Boptimised%5D.webp';

const TIME_TO_UPDATE_IN_MS = 5000;

const BOT_SIZE = 70;

export default function LoadingView() {
  const [loadingText, setLoadingText] = useState('Connecting');
  const bot = useAppSelector(selectBot);

  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingText((prevText) =>
        prevText === 'Connecting' ? 'Still trying to connect' : 'Connecting',
      );
    }, TIME_TO_UPDATE_IN_MS);

    return () => clearInterval(interval);
  }, []);

  return (
    <StyledBox>
      <StyledCenteredStack gap={5}>
        <StyledCenteredStack>
          <StyledCenteredStack gap={3}>
            <StyledImage
              width={BOT_SIZE}
              height={BOT_SIZE}
              src={
                bot.id === 0
                  ? CONFIG.DEFAULT_KNOWZ_AI_BOT.avatar
                  : retrieveImageWithFallback(
                      createPublicImageUrl(getAvatar(bot.image)),
                      BOTS_AVATAR_FALLBACK,
                    )
              }
            />
            <StyledCenteredStack direction="row">
              <Text
                variant="textMd"
                weight="medium"
                color="textSecondary"
              >
                {loadingText}
              </Text>
              <AnimatedDots size="small" />
            </StyledCenteredStack>
          </StyledCenteredStack>
        </StyledCenteredStack>
      </StyledCenteredStack>
    </StyledBox>
  );
}
